import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../app-context';
import { ALL, DAYS_QTR, GET_AMZ_PRODUCT_URL, PAGE_SIZE } from '../../common/constants';
import { getInvAttribute, getOrderTopSku } from '../amazon.services';
import { FormControl, FormControlLabel, Grid, Radio, RadioGroup } from '@mui/material';
import SearchPanel from '../../../components/search-panel/search-panel.component';
import IDropdown from '../../../components/text-component/dropdown/i-dropdown.component';
import IDateField from '../../../components/text-component/i-datefield/i-datefield.component';
import dayjs from 'dayjs';
import { formatTo0Decimal } from '../../common/util.services';
import IGridComponent from '../../../components/grid/i-grid.component';
import { GridColDef } from '@mui/x-data-grid';
import FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

const ProductTopSku = () => {
  const appContext = useContext(AppContext);
  const [product, setProduct] = useState(ALL);
  const [color, setColor] = useState(ALL);
  const [size, setSize] = useState(ALL);
  const [pack, setPack] = useState(ALL);
  const [colorList, setColorList] = useState([]);
  const [sizeList, setSizeList] = useState([]);
  const [packList, setPackList] = useState([]);
  const [prdSaleData, setPrdSaleData] = useState<any>([])
  const [type, setType] = useState('Val');
  const [searchData, setSearchData] = useState<any>({startDate: dayjs().subtract(DAYS_QTR, 'day'), endDate: dayjs(),
                                                     product: ALL, color: ALL, size: ALL, pack: ALL});
  const [startDate, setStartDate] = useState(searchData.startDate);
  const [endDate, setEndDate] = useState(searchData.endDate);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [totalRows, setTotalRows] = useState(0);
  const columns: GridColDef[] = [
    { field: 'rowId', headerName: '#', filterable: false, sortable: false, editable: false, width: 20},
    { field: 'sku', headerName: 'SKU', filterable: false, sortable: false, editable: false, width: 110},
    { field: 'product', headerName: 'Product', filterable: false, sortable: false, editable: false, width: 180},
    { field: 'color', headerName: 'Color', filterable: false, sortable: false, editable: false, width: 150},
    { field: 'size', headerName: 'Size', filterable: false, sortable: false, editable: false, width: 120},
    { field: 'unitCount', headerName: 'Pack', filterable: false, sortable: false, editable: false, width: 80},
    { field: 'quantity', headerName: 'Quantity', filterable: false, sortable: false, editable: false, width: 80,
      valueFormatter: (value) => formatTo0Decimal(value)
    },
    { field: 'saleValue', headerName: 'Order Value', filterable: false, sortable: false, editable: false, width: 95,
      valueFormatter: (value) => formatTo0Decimal(value)
    },
    { field: 'avgValue', headerName: 'Avg. Value', filterable: false, sortable: false, editable: false, width: 90,
      renderCell: (params) => {return formatTo0Decimal(params.row.saleValue/params.row.quantity)}
    },
    { field: 'fbaQty', headerName: 'FBA', filterable: false, sortable: false, editable: false, width: 90,
      renderCell: (params) => {return formatTo0Decimal(params.row.fbaQty)}
    },
    { field: 'awdQty', headerName: 'AWD', filterable: false, sortable: false, editable: false, width: 90,
      renderCell: (params) => {return formatTo0Decimal(params.row.awdQty)}
    }
   ];

  useEffect(() => {
    getPrdSaleData();
  }, [page, pageSize, searchData]);

  function getPrdSaleData() {
    setLoading(true);
    let filter = {startDate: startDate, endDate: endDate, product: product, color: color, size: size, pack: pack, type: type};
    getOrderTopSku(filter, page, pageSize, appContext,
      (response: any) => {
        setPrdSaleData(response.data.content);
        setTotalRows(response.data.totalElements);
        appContext.setShowLoader(false);
        setLoading(false);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
        setLoading(false);
      });
  }

  const search = (data: any) => {
    setSearchData(data);
  }

  const updateAttributeList = (invProduct: any) => {
    getInvAttribute(invProduct, appContext,
      (response: any) => {
        setColorList(response.data[0]);
        setSizeList(response.data[1]);
        setPackList(response.data[2]);
        appContext.setShowLoader(false);
        appContext.setSuccessMessage(response.message)
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
      });
  }

  const onPaginationModelChange = (evt: any) => {
    setPage(evt.page);
    setPageSize(evt.pageSize);
  }

  const exportData = (evt: any) => {
    let header = ["Serial", "SKU", "Product", "Color", "Size", "Pack", "Quantity", "Order Value"];
    let ordData: any = [];
    for(let i = 0; i < prdSaleData.length; ++i) {
      let data = [prdSaleData[i].rowId, prdSaleData[i].sku, prdSaleData[i].product, 
                  prdSaleData[i].color, prdSaleData[i].size, prdSaleData[i].unitCount, 
                  prdSaleData[i].quantity.toLocaleString('en-IN'), 
                  Math.round(prdSaleData[i].saleValue).toLocaleString('en-IN')];
      ordData.push(data);
    }
    const excelSheet = XLSX.utils.book_new();
    XLSX.utils.sheet_add_aoa(excelSheet, [header]);
    XLSX.utils.sheet_add_json(excelSheet, ordData, { origin: 'A2', skipHeader: true });
    const excelBook = { Sheets: { 'Transaction': excelSheet }, SheetNames: ['Transaction'] };
    const excelBuffer = XLSX.write(excelBook, { bookType: 'xlsx', type: 'array', cellStyles:true });
    const excelData = new Blob([excelBuffer], { type: 'xlsx' });
    FileSaver.saveAs(excelData, "Amazon_Top_Selling_SKU.xlsx");
  }

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setType((event.target as HTMLInputElement).value);
  }

  const getSearchComponent = () => {
    return <SearchPanel search={search} formData={searchData} showExportBtn={true} export={exportData}>
      <Grid container spacing={1} width={1200}>
        <Grid xs={2}>
          <IDateField name='startDate' label='Start Date' timeZone="America/Los_Angeles"
            onActionEvent={(e: any) => setStartDate(e)}/>
        </Grid>
        <Grid xs={2}>
          <IDateField name='endDate' label='End Date' timeZone="America/Los_Angeles"
            onActionEvent={(e: any) => setEndDate(e)}/>
        </Grid>
        <Grid xs={1.5}>
          <IDropdown name='product' label='Product' url={GET_AMZ_PRODUCT_URL} allItemRequired={true} required={true}
            onChangeEvent={(e: any) => {setProduct(e.target.value); setColor(ALL); setSize(ALL); 
                                        setPack(ALL); updateAttributeList(e.target.value);}} />
        </Grid>
        <Grid xs={1.5}>
          <IDropdown name='color' label='Color' itemList={colorList} allItemRequired={true} required={true}
            onChangeEvent={(e: any) => {setColor(e.target.value)}}/>
        </Grid>
        <Grid xs={1.5}>
          <IDropdown name='size' label='Size' itemList={sizeList} allItemRequired={true} required={true}
            onChangeEvent={(e: any) => {setSize(e.target.value)}}/>
        </Grid>
        <Grid xs={1.5}>
          <IDropdown name='pack' label='Pack' itemList={packList} allItemRequired={true} required={true}
            onChangeEvent={(e: any) => {setPack(e.target.value)}}/>
        </Grid>
        <Grid xs={2} sx={{ pl: 2, display: 'flex', alignItems: 'center' }}>
          <FormControl>
            <RadioGroup defaultValue="Val" name="type" row={true} onChange={handleChange}>
              <FormControlLabel value="Qty" control={<Radio />} label="Qty" />
              <FormControlLabel value="Val" control={<Radio />} label="Val" />
            </RadioGroup>
          </FormControl>
        </Grid>
      </Grid>
    </SearchPanel>
  }

  return <>
    {getSearchComponent()}
    <IGridComponent title={''} rows={prdSaleData} columns={columns} loading={loading} maxHeight={450}
      paginationType="server" paginationModelChange={onPaginationModelChange} totalRows={totalRows}
      getRowId={(row: any) => row.rowId} showAction={false} />
  </>
}

export default ProductTopSku;

